import React, { useEffect, useState } from "react";
import SetupInspectionList from "../components/setupInspectionList";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ACCESS_DENIED,
  INSPECTION_AUTHORITY,
  SETUP_INSPECTION,
} from "../../../../constant/routeContant";
import * as swInspectionAction from "../../../../redux/storm-water/actions/swInspectionAction";
import { useDispatch, useSelector } from "react-redux";
import { ORG_ID } from "../../../../constant/constant";
import { ToastContainer, toast } from "react-toastify";
import * as clientAction from "../../../../redux/actions/clientAction";
import Loader from "../../../../library/common/Loader";
import * as assetsAction from "../../../../redux/actions/assetsAction";
import { checkPrivileges } from "../../../../utils/rolesHelper";
import { InactiveClient } from "../../../../utils/helper";
import { useDebounce } from "../../../../utils/useDebounceSearch";

const SetupInspectionListContainer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [customerId, setCustomerId] = useState();
  const [clientSearchText, setClientSearchText] = useState("");
  const debouncedClientSearch = useDebounce(clientSearchText, 500);
  const [projectSearchText, setProjectSearchText] = useState("");
  const debouncedProjectSearch = useDebounce(projectSearchText, 500);

  const setupInspection = () => {
    if (InactiveClient()) return;
    navigate(SETUP_INSPECTION);
  };
  const getSwQuestionSetProjectMapList = useSelector(
    (state) => state.getSwQuestionSetProjectMapList,
  );
  const filterObjData = useSelector((state) => state.getSwQuestionSetProjectMapList);
  const getSwQuestionSetProjectMapListData = (data) => {
    dispatch(swInspectionAction.getSwQuestionSetProjectMapListFilterObj(data));
    dispatch(swInspectionAction.getSwQuestionSetProjectMapList(data));
  };
  const updateStatusQuestionSetProjectMap = useSelector(
    (state) => state.updateStatusQuestionSetProjectMap,
  );
  const [clearUpdateQuestionSetStatus, setClearUpdateQuestionSetStatus] =
    useState(false);
  const updateSwQuestionSetProjectMapData = (data) => {
    setClearUpdateQuestionSetStatus(true);
    dispatch(swInspectionAction.updateStatusQuestionSetProjectMap(data));
  };
  const isLoading = useSelector(
    (state) => state.getSwQuestionSetProjectMapList?.isLoading,
  );

  const handleEditOnClick = (row, customerId) => {
    if (InactiveClient()) return;
    sessionStorage.setItem("setupInspectionEditMode", "true");
    sessionStorage.setItem("setupInspectionEditModeProjectData", "true");
    navigate(SETUP_INSPECTION, {
      state: {
        row: row?.mapId,
        editMode: true,
        projectNumber: row?.projectNo,
        projectName: row?.projectName,
        projectId: row?.projectId,
        customerId: customerId,
        customerName: row.customerName,
      },
    });
  };

  const handleManageOnClick = (row) => {
    navigate(INSPECTION_AUTHORITY, {
      state: {
        row: row?.mapId,
        manage: true,
      },
    });
  };

  useEffect(() => {
    if (
      updateStatusQuestionSetProjectMap?.status === "SUCCESS" &&
      updateStatusQuestionSetProjectMap?.isLoading === false &&
      clearUpdateQuestionSetStatus &&
      !["HBNG020", "HBNG021"].includes(
        updateStatusQuestionSetProjectMap?.data?.responseCode,
      )
    ) {
      toast("Question Set Project Map Status Updated successfully");
    }
  }, [updateStatusQuestionSetProjectMap]);

  function handleAllProjectSearch(event, value, customerId) {
    setProjectSearchText(event.target.value);
    setCustomerId(customerId);
  }

  const allProject = useSelector((state) => state.getAssetDynomoList);
  const isProjectLoading = allProject?.isLoading;

  const allClients = useSelector((state) => state.searchAllClientsReducerData);
  const isSearchClientLoading = allClients.isLoading;
  const searchClient = (event) => {
    setClientSearchText(event.target.value);
  };
  const showLoader = useSelector(
    (state) => state.updateStatusQuestionSetProjectMap?.isLoading,
  );

  useEffect(() => {
    dispatch(
      assetsAction.getAssetDynomoList({
        searchText: debouncedProjectSearch,
        type: 5,
        orgId: customerId,
      }),
    );
  }, [debouncedProjectSearch]);

  useEffect(() => {
    dispatch(clientAction.searchAllClients(debouncedClientSearch));
  }, [debouncedClientSearch]);

  return (
    <>
      {checkPrivileges([12, 99, 100, 101]) ? (
        <>
          {showLoader && <Loader />}

          <SetupInspectionList
            isLoading={isLoading}
            swQuestionSetProjectMapList={
              isLoading
                ? []
                : getSwQuestionSetProjectMapList?.data?.qsProjectMapList
            }
            setupInspection={setupInspection}
            count={getSwQuestionSetProjectMapList?.data?.count}
            getSwQuestionSetProjectMapListData={
              getSwQuestionSetProjectMapListData
            }
            handleEditOnClick={handleEditOnClick}
            updateSwQuestionSetProjectMapData={
              updateSwQuestionSetProjectMapData
            }
            handleAllProjectSearch={handleAllProjectSearch}
            isProjectLoading={isProjectLoading}
            allProjects={allProject?.data}
            allClients={allClients?.data}
            isSearchClientLoading={isSearchClientLoading}
            searchClient={searchClient}
            handleManageOnClick={handleManageOnClick}
            updateStatusQuestionSetProjectMap={
              updateStatusQuestionSetProjectMap
            }
            projectData={location?.state}
            filterObjDatas={filterObjData}
          />
          <ToastContainer />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
};

export default SetupInspectionListContainer;
